<div class="messages-trigger position-relative">
  <button class="bell-btn position-relative" (click)="onBellClick($event)" type="button">
    <img
      [src]="
        !isOpen() && !isChatPage()
          ? 'assets/images/icons/message.svg'
          : 'assets/images/icons/chat_active.svg'
      "
      alt="messages"
      width="20"
      height="22"
    />
    @if (hasUnviewedMessages()) {
      <span class="unviewed-dot"></span>
    }
  </button>

  @if (isOpen()) {
    <div class="messages-panel" (click)="onPanelClick($event)">
      <div class="panel-header d-flex align-items-center justify-content-between">
        <span class="fw-medium text-sm">Messages</span>
        @if (!loading() && messages().length > 0) {
          <button class="mark-all-btn" type="button" (click)="onNavigateTomessagesPage()">
            See all
          </button>
        }
      </div>

      @if (loading()) {
        <div class="messages-list">
          @for (item of [].constructor(5); track $index) {
            <div class="message-item d-flex align-items-start gap-3">
              <p-skeleton shape="circle" size="40px" styleClass="flex-shrink-0" />
              <div class="notification-body flex-grow-1 d-flex flex-column gap-2">
                <p-skeleton width="220px" height="14px" />
                <p-skeleton width="100px" height="12px" />
              </div>
            </div>
          }
        </div>
      }

      @if (!loading() && messages().length === 0) {
        <div class="empty-state d-flex flex-column align-items-center justify-content-center gap-3">
          <img src="assets/images/no_messages.svg" class="w-50" alt="No messages" width="100" />
        </div>
      }

      @if (!loading() && messages().length > 0) {
        <div class="messages-list">
          @for (notification of messages(); track notification.id) {
            <div
              class="message-item d-flex align-items-start gap-3"
              [class.unread]="notification.countUnreadedMessage"
              (click)="onItemClick(notification)"
            >
              @if (
                notification.members[0].avatar &&
                notification.members[0].avatar !== 'https://dev-backend.shuwier.com/'
              ) {
                <img
                  [src]="notification.members[0].avatar"
                  alt="Notification icon"
                  width="21"
                  class="notification-icon flex-shrink-0"
                  height="21"
                />
              } @else {
                <div class="notification-icon flex-shrink-0 text-uppercase text-white text-lg">
                  {{ notification.members[0].name[0] }}
                </div>
              }

              <div class="message-body flex-grow-1">
                <div class="d-flex justify-content-between">
                  <p class="message-name text-sm mb-1" [class.has-link]="hasData(notification)">
                    {{ notification.members[0].name }}
                  </p>
                  <p class="lastMessageTime" [class.has-link]="hasData(notification)">
                    {{ timeAgo(notification.lastMessageAt!) }}
                  </p>
                </div>
                <span class="last-message text-sm">
                  {{ notification?.lastMessage?.text }}
                </span>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (isOpenMessage()) {
    <div class="messages-panel" (click)="onPanelClick($event)">
      <div class="panel-header d-flex align-items-center justify-content-between">
        <span class="fw-medium text-sm">Messages</span>
        @if (!loading() && messages().length > 0) {
          <button class="mark-all-btn" type="button" (click)="onNavigateTomessagesPage()">
            See all
          </button>
        }
      </div>

      @if (loading()) {
        <div class="messages-list">
          @for (item of [].constructor(5); track $index) {
            <div class="message-item d-flex align-items-start gap-3">
              <p-skeleton shape="circle" size="40px" styleClass="flex-shrink-0" />
              <div class="notification-body flex-grow-1 d-flex flex-column gap-2">
                <p-skeleton width="220px" height="14px" />
                <p-skeleton width="100px" height="12px" />
              </div>
            </div>
          }
        </div>
      }

      @if (!loading() && messages().length === 0) {
        <div class="empty-state d-flex flex-column align-items-center justify-content-center gap-3">
          <img src="assets/images/icons/no-messages.svg" alt="No messages" width="100" />
          <p class="mb-0">No messages yet</p>
        </div>
      }

      @if (!loading() && messages().length > 0) {
        <div class="messages-list">
          @for (notification of messages(); track notification.id) {
            <div
              class="message-item d-flex align-items-start gap-3"
              [class.unread]="!notification.is_read"
              (click)="onItemClick(notification)"
            >
              <div class="notification-icon flex-shrink-0 text-white text-lg">
                {{ notification.members[0].name[0] }}
              </div>

              <div class="notification-body flex-grow-1">
                <p class="notification-title text-sm mb-1" [class.has-link]="hasData(notification)">
                  {{ notification.body }}
                </p>
                <span class="notification-date text-sm"> </span>
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
